import axios from "axios";
import config from "../../../settings/config";
import { handleError } from "../../../network/servicErrorHandling";

async function managementShopProducts(
  uid,
  searchKey,
  nextUrl,
  shop_category = ""
) {
  return Promise.resolve().then((v) =>
    axios
      .get(
        nextUrl
          ? nextUrl.replace("http:", "https:")
          : `${config.baseUrl}v1/shops/${uid}/products?q=${searchKey}&shop_category=${shop_category}`
      )
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

async function managementCustomProducts(uid, searchKey, nextUrl) {
  return Promise.resolve().then((v) =>
    axios
      .get(
        nextUrl
          ? nextUrl.replace("http:", "https:")
          : `${config.baseUrl}v1/shops/${uid}/product-requests?q=${searchKey}`
      )
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

async function change_stock(uid, id, has_stock) {
  return Promise.resolve().then((v) =>
    axios
      .patch(`${config.baseUrl}v1/shops/${uid}/products/${id}`, {
        has_stock: has_stock,
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

async function showProduct(uid, id, show_on_menu) {
  return Promise.resolve().then((v) =>
    axios
      .patch(`${config.baseUrl}v1/shops/${uid}/products/${id}`, {
        show_on_menu: show_on_menu,
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

async function deleteProduct(uid, id) {
  return Promise.resolve().then((v) =>
    axios
      .delete(`${config.baseUrl}v1/shops/${uid}/products/${id}`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

async function activatShop(uid) {
  return Promise.resolve().then((v) =>
    axios
      .put(`${config.baseUrl}v1/shops/${uid}/activation`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

async function getGityShopCategoriesService(uid) {
  return Promise.resolve().then((v) =>
    axios
      .get(`${config.baseUrl}v1/shops/${uid}/gity-shop-categories`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

export {
  managementShopProducts,
  managementCustomProducts,
  change_stock,
  showProduct,
  deleteProduct,
  activatShop,
  getGityShopCategoriesService,
};
